import md5 from 'blueimp-md5';
import React from 'react';
import { Button } from 'antd';
import Texty from 'rc-texty';

import config from '@/service/config';
import { isImg as imgStr, mdId } from '../../utils';

import compConfig from '../../edit/template/component.config';
// import { re } from 'prettier/lib';

export const isImg = imgStr;

export const getChildrenToRender = (item, i) => {
  let tag = item.name && item.name.indexOf('title') === 0 ? 'h1' : 'div';
  tag = item.href ? 'a' : tag;
  let children = typeof item.children === 'string' && item.children.match(isImg)
    ? React.createElement('img', { src: item.children, alt: 'img' })
    : React.createElement('span', { dangerouslySetInnerHTML: { __html: item.children } });
  if (item.name.indexOf('button') === 0) {
    if (typeof item.children === 'object') {
      children = React.createElement(Button, {
        ...item.children,
        'data-edit': 'link,text',
      }, React.createElement('span', { dangerouslySetInnerHTML: { __html: item.children.children } }));
    } else {
      // 去除 linkA, linkA 全部用文字编辑的 #
      item['data-edit'] = 'linkA,text';
    }
  }
  if (item.name.indexOf('link') === 0) {
    item['data-edit'] = 'linkA,text';
  }
  if (item.texty) {
    item['data-edit'] = 'texty';
    return (
      <div key={i.toString} {...item}>
        <Texty type="mask-bottom">{item.children}</Texty>
      </div>
    );
  }
  return React.createElement(tag, { key: i.toString(), ...item }, children);
};

export function getEditDomData(children) {
  const data = {};
  const doms = Array.prototype.slice.call(children);
  doms.forEach((item) => {
    // const dataId = item.getAttribute('data-id');
    const dataId = mdId[item.getAttribute('data-id')];
    if (!dataId) {
      return;
    }
    const comp = item.getAttribute('data-comp');
    const tempNames = dataId.split('-');
    let tempData = data[tempNames[0]] || {};
    const rect = item.getBoundingClientRect();
    /* const style = typeof window !== 'undefined' && document.defaultView ?
        document.defaultView.getComputedStyle(child) : {}; */
    tempData = {
      rect,
      // style,
      dataId,
      item,
      comp,
    };
    data[tempNames[0]] = tempData;
  });
  return data;
}

export const setDataIdToDataSource = (data, dataId) => {
  let id;
  const objectForEachChild = (item, key) => {
    if (typeof item === 'object') {
      if (Array.isArray(item)) {
        item.forEach((cItem, i) => {
          if (typeof cItem === 'object') {
            // 数组必需加name;
            const name = cItem.name ? `array_name=${cItem.name}` : i;
            objectForEachChild(cItem, `${key}&${name}`);
            id = md5(`${dataId}-${key}&${name}`);
            mdId[id] = `${dataId}-${key}&${name}`;
            cItem['data-id'] = id;
            // cItem['data-id'] = `${dataId}-${key}&${name}`;
          }
        });
      } else if (item) {
        Object.keys(item).forEach((cKey) => {
          const cItem = item[cKey];
          objectForEachChild(cItem, `${key}&${cKey}`);
        });
        if (key in compConfig) {
          item['data-edit'] = key;
        } else if (item.children && typeof item.children !== 'object') {
          if (item.children.match(isImg) || (item.name && item.name.indexOf('image') === 0)) {
            item['data-edit'] = 'image';
          } else {
            item['data-edit'] = 'text';
          }
        }
        id = md5(`${dataId}-${key}`);
        mdId[id] = `${dataId}-${key}`;
        item['data-id'] = id;
        // item['data-id'] = `${dataId}-${key}`;;
      }
    }
  };
  Object.keys(data).forEach((key) => {
    const item = data[key];
    objectForEachChild(item, key);
  });
  return data;
};

export function tracker(param) {
  const params = { type: 'pv', event: 'view' };
  // params.param = param;
  params.pageId = param.pageId || '';
  params.host = '';
  params.href = window.location.href;
  params.path = window.location.search;
  params.query = window.location.hash;
  // params.userid = param.userid || '';
  params.uid = param.uid || '';
  // params.channel = to.query.channel;
  params.ua = navigator.userAgent;
  params.from = '宣传推广';
  params.parkId = param.parkId || '';
  params.bizId = param.bizId || '';
  const list = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key in params) {
    // eslint-disable-next-line no-prototype-builtins
    if (params.hasOwnProperty(key)) {
      list.push(`${key}=${encodeURIComponent(params[key] || '')}`);
    }
  }
  new window.Image().src = `${config.BASEPOINT}?${list.join('&')}`;
}
